module.exports = __webpack_public_path__ + "img/recycling-recycle.07baba81.svg";